// Transact reads for the public storefront (publications / document requests),
// via the `public-new` router.
//
// Why `public-new` and NOT `public`: the old `/public/*` router is ~10x faster
// but serves STALE data with caching that cannot be corrected (it bit OMT VIP).
// `/public-new/*` is `cache-control: no-store` — always fresh, currently
// uncached. Proper caching is planned for `public-new`, so this site inherits
// it. Do not "optimize" these back to `/public`.
//
// Orders and customers stay on the authed module router — they 401 on the
// public routers by design.
export default function (axios) {
  return {
    getProducts(params) {
      return axios
        .get('/public-new/transact/products', { params })
        .then((res) => res.data)
    },

    getProduct(id, params) {
      return axios
        .get(`/public-new/transact/products/${id}`, params)
        .then((res) => res.data)
        .catch()
    },

    getProductTypes(params) {
      return axios
        .get(`/public-new/transact/product-types`, params)
        .then((res) => res.data.results)
        .catch()
    },

    // NB stays on /modules: product-variants 401s on the public routers.
    getProductVariants(productId, params = {}) {
      return axios
        .get(`/modules/transact/product-variants`, {
          params: {
            product_id: productId,
            ...params.params,
          },
          ...params,
        })
        .then((res) => res.data.results)
        .catch()
    },
  }
}
